module.exports = __webpack_public_path__ + "img/手与花装饰-2.ebbd92bb.jpg";